import axios from "../config/axios";
import config from "../config/config";
import browser from "browser-detect";
var apiUrl = config.baseUrl;

export const register = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/register`,
            'data': data
        });

        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const login = async (data) => {
    console.log('datssssa: ', data);
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/login`,
            'data': data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            success: (response && response.data && response.data.success) ? response.data.success : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            authToken: (response && response.data && response.data.token) ? response.data.token : null,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
            authToken: null,
        }
    }
}

export const getUserLocation = async () => {
    try {
        let loginHistory = {};
        let respData = await axios({
            'method': "get",
            'url': config.getLoginInfo,
        });
        if (respData) {
            const browserRes = browser();
            respData = respData?.data;
            // loginHistory.countryName = respData.country_name;
            // loginHistory.countryCode = respData.country_calling_code;
            // loginHistory.ipaddress = respData.ip;
            // loginHistory.region = respData.region;
            // loginHistory.country_code = respData.country_code;
            // loginHistory.timezone = respData.timezone;
            // loginHistory.country_capital = respData.country_capital;
            // loginHistory.city = respData.city;
            // loginHistory.country = respData.country;

            loginHistory.countryName = respData.countryName;
            loginHistory.countryCode = respData?.country_calling_code;
            loginHistory.ipaddress = respData.ipAddress;
            loginHistory.region = respData.regionName;
            loginHistory.country_code = respData.countryCode;
            loginHistory.timezone = respData.timeZone;
            loginHistory.country_capital = respData.continent;
            loginHistory.city = respData.cityName;
            loginHistory.country = respData.countryName;


            loginHistory.broswername = browserRes.name;
            loginHistory.ismobile = browserRes.mobile;
            loginHistory.os = browserRes.os;
        }
        console.log(loginHistory, 'loginHistory')
        return await loginHistory;
    } catch (err) {
        return null;
    }
};


export const forgotpassword = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/forget-password`,
            data: data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const resetpassword = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/reset-password`,
            data: data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const verifyEmail = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/email-verify`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}



export const resendOTP = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/resend-otp`,
            data: data
        });
        console.log(response, 'responseee')
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const getReferralList = async (data) => {
    try {
        let response = await axios({
            method: 'get',
            url: `${apiUrl}/referral-data?skip=` +
                data.skip +
                `&limit=` +
                data.limit
        })
        return {
            result: (response && response.data && response.data.result) ? response.data.result : [],
            userData: (response && response.data && response.data.userData) ? response.data.userData : {},
            totalrecords: (response && response.data && response.data.totalrecords) ? response.data.totalrecords : 0,
            status: (response && response.data && response.data.status) ? response.data.status : false,
            isKyc: (response && response.data && response.data.isKyc) ? response.data.isKyc : "",
        }
    } catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const resendPhoneOTP = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/resend-phoneotp`,
            data: data
        });
        console.log(response, 'responseee')
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const verifyPhoneNo = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/verify-phoneno`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}



export const kycReq = async (formData) => {
    try {
        const formDataToSend = new FormData();
        formDataToSend.append('idType', formData.idType);
        formDataToSend.append('frontImage', formData.frontImage);
        if (formData.backImage) {
            formDataToSend.append('backImage', formData.backImage);
        }
        formDataToSend.append('walletAddress', formData.walletAddress);
        formDataToSend.append('agreeTerms', formData.agreeTerms);

        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/kyc-request`,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: formData
        });
        console.log(response, 'responseee')
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getKycInfo = async (address) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/user-kyc-info?address=${address}`
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            data: response?.data?.data || {},
            encryptuserId: response?.data?.encryptuserId || "",
            ref: response?.data?.ref || "0x0000000000000000000000000000000000000000",
            referralId: response?.data?.referralId || "",
            wallet: response?.data?.wallet || "",
            alreadywallet: response?.data?.alreadywallet || "false",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
            encryptuserId: ""
        }
    }
}


export const savePurchase = async (data) => {

    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/buy-token`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            data: response?.data?.data || {},
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const saveReward = async (data) => {

    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/buy-reward`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            data: response?.data?.data || {},
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getTxHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/transaction-history?limit=${data.limit}&skip=${data.skip}`
        });
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            result: response?.data?.result || {},
            totalRecords: response?.data?.totalrecords || 0,
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getRewardHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/reward-history?limit=${data.limit}&skip=${data.skip}`
        });
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            result: response?.data?.result || {},
            totalRecords: response?.data?.totalrecords || 0,
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getLatestCount = async () => {

    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/latest-usercount`
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            count: response?.data?.count || 0,
            referralwintoken: response?.data?.referralwintoken || 0,
            bonuswintoken: response?.data?.bonuswintoken || 0,
            totalWintoken: response?.data?.totalWintoken || 0,
            totalBonustoken: response?.data?.totalBonustoken || 0,
            totalinvestment: response?.data?.totalinvestment || 0,
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const referralTokens = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/referral-tokens`
        });
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            totalWintoken: response?.data?.totalWintoken || 0
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getTerms = async (identifier) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetch-cms?identifier=${identifier}`
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            content: (response && response.data && response.data.result) ? response.data.result : ""
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            content: ""
        }
    }
}

export const getFaqlistAction = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/get-faq-list`,
            'data': data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            message: (response && response.data && response.data.message) ? response.data.message : "",
            result: (response && response.data && response.data.result) ? response.data.result : {},
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed",
            authToken: null,
        }
    }
}


export const getUserInfo = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/user-info`,
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
            result: (response && response.data && response.data.result) ? response.data.result : {},
        }
    }
    catch (err) {
        return {
            status: false,
            message: "Failed",
            authToken: null,
        }
    }
}


export const UpdateWallet = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/update-wallet`,
            'data': data
        });

        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}



export const getParentReferral = async (data) => {
    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/get-parent-user`,
            data: data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : {},
            wallet: (response && response.data && response.data.wallet) ? response.data.wallet : ""

        }
    } catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}



export const saveClaimBid = async (data) => {

    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/claim-bid`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            data: response?.data?.data || {},
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}
export const getClaimHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/claimbid-history?limit=${data.limit}&skip=${data.skip}`
        });
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            result: response?.data?.result || {},
            totalRecords: response?.data?.totalrecords || 0,
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}